// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
    background-color: var(--white) !important;
    border-radius: 8px !important ;
    box-shadow: var(--shadow-sm) !important;
    margin-bottom: var(--spacing-lg) !important;
    overflow: hidden !important;
  }
  
  .card-header {
    /* background-color: rgba(255, 215, 0, 0.3) !important;
  color: var(--primary-grey) !important; */
  background-color: #959595 !important;
  color: #fff !important;
    padding: var(--spacing-sm) var(--spacing-xl) !important;
    border-bottom: 1px solid var(--border-color) !important;
  }
  
  .card-header h3 {
    font-size: 15px !important;
  font-weight: normal !important;
    margin-bottom: 0;
  }
  
  .card-body {
    padding: var(--spacing-sm) !important;
    padding-left: var(--spacing-lg) !important;
    padding-right: var(--spacing-lg) !important;
  }`, "",{"version":3,"sources":["webpack://./src/styles/components/card.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,8BAA8B;IAC9B,uCAAuC;IACvC,2CAA2C;IAC3C,2BAA2B;EAC7B;;EAEA;IACE;0CACsC;EACxC,oCAAoC;EACpC,sBAAsB;IACpB,uDAAuD;IACvD,uDAAuD;EACzD;;EAEA;IACE,0BAA0B;EAC5B,8BAA8B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,0CAA0C;IAC1C,2CAA2C;EAC7C","sourcesContent":[".card {\r\n    background-color: var(--white) !important;\r\n    border-radius: 8px !important ;\r\n    box-shadow: var(--shadow-sm) !important;\r\n    margin-bottom: var(--spacing-lg) !important;\r\n    overflow: hidden !important;\r\n  }\r\n  \r\n  .card-header {\r\n    /* background-color: rgba(255, 215, 0, 0.3) !important;\r\n  color: var(--primary-grey) !important; */\r\n  background-color: #959595 !important;\r\n  color: #fff !important;\r\n    padding: var(--spacing-sm) var(--spacing-xl) !important;\r\n    border-bottom: 1px solid var(--border-color) !important;\r\n  }\r\n  \r\n  .card-header h3 {\r\n    font-size: 15px !important;\r\n  font-weight: normal !important;\r\n    margin-bottom: 0;\r\n  }\r\n  \r\n  .card-body {\r\n    padding: var(--spacing-sm) !important;\r\n    padding-left: var(--spacing-lg) !important;\r\n    padding-right: var(--spacing-lg) !important;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
